import { Participant, Upload } from '@range.io/basic-types'
import { tagged } from '@range.io/functional'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { URL_SEARCH_ORDER, useImageUrl } from '../components-reusable/hooks/useImageUrl.js'
import { Box } from '../components-reusable/index.js'
import { ReduxSelectors } from '../redux/index.js'
import MediaViewItemContent from './MediaViewItemContent.js'
import MediaViewItemFooter from './MediaViewItemFooter.js'
import MediaViewItemHeader from './MediaViewItemHeader.js'

const MediaViewItem = ({
    collaborationName,
    participant,
    collaborationTagNames,
    createdAt,
    description,
    name,
    fileType,
    fileSize,
    id,
    isSelected,
    locationLabel,
    mapPinType,
    upload,
    onClick,
    onDeleteClick,
    onDownloadClick,
    onLocationClick,
    onSelectClick,
    parentId,
    tagNames,
    identifierComponent,
    version,
    commentsCount,
}) => {
    const fakeUpload = { name, description, fileType, fileSize } // TODO: pass in a real Upload?
    const willHaveThumbnail = Upload.willHaveThumbnail(fakeUpload)
    const { url } = willHaveThumbnail ? useImageUrl(URL_SEARCH_ORDER.ANNOTATED_THUMBNAIL_1, id) : {}
    const { url: locationSnapshotUrl } = useImageUrl(URL_SEARCH_ORDER.LOCATION_THUMBNAIL_0, parentId)
    const allowUploadDelete = useSelector(ReduxSelectors.isDeleteAllowed('upload', upload))

    return (
        <Box css={{ aspectRatio: '444 / 427', width: '100%', maxWidth: '444px' }}>
            <MediaViewItemHeader
                date={createdAt}
                allowDelete={allowUploadDelete}
                onDeleteClick={onDeleteClick}
                onDownloadClick={onDownloadClick}
                participant={participant}
            />
            <MediaViewItemContent
                data-cy="media-view-item"
                {...fakeUpload}
                imageUrl={url}
                isSelected={isSelected}
                onClick={onClick}
                onSelectClick={onSelectClick}
                willHaveThumbnail={willHaveThumbnail}
                version={version}
                commentsCount={commentsCount}
            />
            <MediaViewItemFooter
                collaborationName={collaborationName}
                collaborationTagNames={collaborationTagNames}
                isImage={Upload.isImage(fakeUpload)}
                locationLabel={locationLabel}
                locationSnapshotUrl={locationSnapshotUrl}
                mapPinType={mapPinType}
                onLocationClick={onLocationClick}
                tagNames={tagNames}
                identifierComponent={identifierComponent}
            />
        </Box>
    )
}

MediaViewItem.propTypes = {
    collaborationName: PropTypes.string.isRequired,
    createdAt: PropTypes.object.isRequired, // Date
    description: PropTypes.string,
    fileSize: PropTypes.number,
    fileType: PropTypes.string.isRequired,
    isSelected: PropTypes.bool,
    locationLabel: PropTypes.string.isRequired,
    name: PropTypes.string,
    onClick: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    onDownloadClick: PropTypes.func.isRequired,
    onSelectClick: PropTypes.func.isRequired,
    tagNames: PropTypes.arrayOf(PropTypes.string).isRequired,
    thumbnailUrl: PropTypes.string,
    participant: tagged.typeIsRequired(Participant),
}

export default MediaViewItem
